module.exports = __webpack_public_path__ + "img/home-bg.99da6b9d.png";